import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c3f5e0a&"
import script from "./scripts.vue?vue&type=script&lang=js&"
export * from "./scripts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports